// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-body-container {
  padding: 10px 5px;
}
.legend-body-container .legend-row {
  padding: 10px 0px;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/legends/legend-body/legend-body.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAAE;EACE,iBAAA;AAEJ","sourcesContent":[".legend-body-container {\r\n  padding: 10px 5px;\r\n  .legend-row {\r\n    padding: 10px 0px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
